import { useEffect, useState } from "react";
import { nameConverter } from "../../services/help";
import { IoMdRefresh } from "react-icons/io";
import MoreFiltersNotFound from "./MoreFiltersNotFound";


const MoreFiltersBox = ({ data, values, setValues, setChartValues, chartValues }) => {

    const obj = data?.data
    const type = data?.type ? data.type : 1
    const mode = data?.mode ? data.mode : false
    const dataValues = mode ? chartValues ? chartValues : values : values

    const [openClose, setOpenClose] = useState(-1)

    const handleChangeRadioButton = (e) => {
        //remove secondarySubjectCategoryId when primary change
        if (e.target.name === 'primarySubjectCategoryId') {
            const newVals = { ...dataValues }
            delete newVals.secondarySubjectCategoryId
            delete newVals.primarySubjectCategoryId
            //default filter work
            if (!mode) {
                setValues({
                    ...newVals,
                    [e.target.name]: {
                        value: e.target.value,
                        name: e.target.id,
                    }
                })
            } else {
                //filter mode chart
                setChartValues({
                    ...newVals,
                    [e.target.name]: {
                        value: e.target.value,
                        name: e.target.id,
                    }
                })
            }
        } else {
            if (!mode) {
                setValues({
                    ...dataValues,
                    [e.target.name]: {
                        value: e.target.value,
                        name: e.target.id,
                    }
                })
            } else {
                //filter mode chart
                setChartValues({
                    ...dataValues,
                    [e.target.name]: {
                        value: e.target.value,
                        name: e.target.id,
                    }
                })
            }
        }
    }

    const handleResetFilter = (val) => {
        const newVals = { ...dataValues }
        delete newVals[val]
        if (val === 'primarySubjectCategoryId') {
            delete newVals['secondarySubjectCategoryId']
        }

        mode ? setChartValues({ ...newVals }) : setValues({ ...newVals })
    }

    useEffect(() => setOpenClose(-1), [data]);

    return (obj &&
        <>
            <div className={`moreFilters ${mode ? 'chartModeFilters' : ''}`}>
                {/* users */}
                {type === 1 && (
                    Object.keys(obj)?.map((item, i) => (obj?.[item]?.length > 0 ?
                        <div key={i} className={`filters ${openClose === i && 'true'}`}>
                            <label>{nameConverter(item)} <button type="button" className="resetBtnFilter" disabled={dataValues?.filterUserId?.value ? false : true} onClick={() => handleResetFilter('filterUserId')}><IoMdRefresh /></button></label>
                            {obj?.[item].map(items => (
                                <label key={items.userId}>
                                    <input type="radio" name="filterUserId" value={items.userId} id={items.fullName != ' ' ? items.fullName : items.userId} onChange={handleChangeRadioButton} checked={items.userId === parseInt(dataValues?.filterUserId?.value) ? true : false} />
                                    <span className={`radioClick ${items.userId === parseInt(dataValues?.filterUserId?.value) ? 'active' : ''}`}>
                                        {items.fullName != ' ' ? items.fullName : 'بدون نام'} <small>{items.value}</small>
                                    </span>
                                </label>
                            ))}
                            {openClose != i && obj?.[item]?.length > 4 && (<button className={`${openClose}`} onClick={() => setOpenClose(i)}>مشاهده همه</button>)}
                        </div>

                        : <MoreFiltersNotFound name={item} reset={handleResetFilter} key={i} />

                    ))
                )}
                {/* year and ages */}
                {type === 2 && (
                    Object.keys(obj)?.map((item, i) => (obj?.[item]?.length > 0 ?
                        <div key={i} className={`filters ${openClose === i && 'true'}`}>
                            <label>{nameConverter(item)} <button type="button" className="resetBtnFilter" disabled={dataValues?.[item]?.value ? false : true} onClick={() => handleResetFilter(item)}><IoMdRefresh /></button></label>
                            {obj?.[item].map((items, index) => (
                                <label key={index ^ 2 * 3}>
                                    <input type="radio" name={item} value={items.id} id={items.text} onChange={handleChangeRadioButton} checked={items.id === dataValues?.[item]?.value ? true : false} />
                                    <span className="radioClick">
                                        {items.text} <small>{items.total}</small>
                                    </span>
                                </label>
                            ))}
                            {openClose != i && obj?.[item]?.length > 4 && (<button className={`${openClose}`} onClick={() => setOpenClose(i)}>مشاهده همه</button>)}
                        </div>

                        : <MoreFiltersNotFound name={item} reset={handleResetFilter} key={i} />
                    ))
                )}
                {/* Categoreis */}
                {type === 3 && (
                    Object.keys(obj)?.map((item, i) => (obj?.[item]?.length > 0 ?
                        <div key={i} className={`filters ${openClose === i && 'true'}`}>
                            <label>{nameConverter(item)} <button type="button" className="resetBtnFilter" disabled={dataValues?.primarySubjectCategoryId?.value ? false : true} onClick={() => handleResetFilter('primarySubjectCategoryId')}><IoMdRefresh /></button></label>
                            {obj?.[item].map((items, index) => (
                                <label key={index ^ 2 * 3}>
                                    <input type="radio" name="primarySubjectCategoryId" value={items.id} id={items.text} onChange={handleChangeRadioButton} checked={items.id == dataValues?.primarySubjectCategoryId?.value ? true : false} />
                                    <span className="radioClick">
                                        {items.text} <small>{items.total}</small>
                                    </span>
                                </label>
                            ))}
                            {openClose != i && obj?.[item]?.length > 4 && (<button className={`${openClose}`} onClick={() => setOpenClose(i)}>مشاهده همه</button>)}
                        </div>

                        : <MoreFiltersNotFound name={item} reset={handleResetFilter} key={i} />
                    ))
                )}
                {/* SecoundCategoreis */}
                {type === 4 && (
                    Object.keys(obj)?.map((item, i) => (obj?.[item]?.length > 0 ?
                        <div key={i} className={`filters ${openClose === i && 'true'}`}>
                            <label>{nameConverter(item)} <button type="button" className="resetBtnFilter" disabled={dataValues?.secondarySubjectCategoryId?.value ? false : true} onClick={() => handleResetFilter('secondarySubjectCategoryId')}><IoMdRefresh /></button></label>
                            {obj?.[item].map((items, index) => (
                                <label key={index ^ 2 * 3}>
                                    <input type="radio" name="secondarySubjectCategoryId" value={items.id} id={items.text} onChange={handleChangeRadioButton} checked={items.id == dataValues?.secondarySubjectCategoryId?.value ? true : false} />
                                    <span className="radioClick">
                                        {dataValues?.primarySubjectCategoryId?.name} - {items.text} <small>{items.total}</small>
                                    </span>
                                </label>
                            ))}
                            {openClose != i && obj?.[item]?.length > 4 && (<button className={`${openClose}`} onClick={() => setOpenClose(i)}>مشاهده همه</button>)}
                        </div>

                        : <MoreFiltersNotFound name={item} reset={handleResetFilter} key={i} />

                    ))
                )}

            </div>

        </>
    );
}

export default MoreFiltersBox;